import type { NavigatorProps } from "./types-navigator";
import { useNavigator } from "./use-navigator";
import { NavigatorView } from "./view-navigator";

export function Navigator(props: NavigatorProps) {
  const vm = useNavigator(props);

  return <NavigatorView {...vm} />;
}

export type * from "./types-navigator";
